/*
 * @Description: 
 * @Author: ywj
 * @Date: 2024-11-29 09:18:15
 * @LastEditTime: 2024-12-20 17:33:08
 * @LastEditors: ywj@originqc.com
 */
import './index.scss';
import RouterView from '../../router/index';
import PageHeader from '../page-header';
import FooterBottom from '../page-footer/footer-bottom';

const Layout = () => {



  return (
    <>
      <PageHeader></PageHeader>
      <section className={ 'page-container no-footer'}>
        <RouterView></RouterView>
      </section>
    <FooterBottom></FooterBottom>
    </>
  )
}
export default Layout
